import { render, staticRenderFns } from "./TeaserList.vue?vue&type=template&id=3b58b767&lang=pug&"
import script from "./TeaserList.vue?vue&type=script&lang=js&"
export * from "./TeaserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports